export const TEST_ID = 'formulationDocumentStatements';

export const DOCUMENT_LINK_TARGET = '_blank';
